export const SESSION_KEY = {
  USER_DATA: 'USER_INFO',
  APP_TYPE_ID: 'APP_TYPE_ID',
  I_18_NEXT_LANG: 'i18nextLng',
};
